import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';

@Directive({
    selector: '[mzDiffTiming]',
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: MzDiffTimingDirective,
        multi: true
    }]
})
export class MzDiffTimingDirective implements Validator {

    @Input() start: string;
    @Input() finish: string;

    validate(control: AbstractControl): ValidationErrors | null {
        const difference = (+new Date(this.finish) - +new Date(this.start)) / 1000 / 60;
        if (control.value > difference) {
            return {difference: 'Продолжительность теста больше отведенного времени'};
        } else {
            return null;
        }
    }

}
